export const portfolioData = {
  personal: {
    name: "Andy Luu",
    title: "Technical Product Manager",
    location: "Vancouver, BC",
    email: "aluu.life@gmail.com",
    tagline: "Building products at the intersection of technology and human connection.",
    about: [
      "Technical Product Manager with a track record of leading complex enterprise migrations, launching new products, and building ventures from 0 to 1. Currently at Global Relay, where I spearhead the migration of core systems responsible for over 50% of company revenue\u2014ensuring seamless, zero-downtime transitions for thousands of clients.",
      "Beyond my day-to-day, I\u2019m drawn to building things that bring people together\u2014whether that\u2019s shipping enterprise software, designing community experiences, or coaching individuals on communication. I believe the best products come from deeply understanding people."
    ],
    links: {
      linkedin: "https://linkedin.com/in/aluu",
      github: "https://github.com/andyl2020",
    }
  },
  experience: [
    {
      company: "Global Relay",
      role: "Technical Product Manager",
      period: "2022 \u2014 Present",
      location: "Vancouver, BC",
      highlights: [
        "Spearheading migration of a core legacy system responsible for 50%+ of company revenue, ensuring zero-downtime transition for thousands of enterprise clients",
        "Partnered cross-functionally with Design, Engineering, and Analytics to oversee live operations and roadmap execution for five enterprise products",
        "Owned product vision for a new, scalable authorization system, modernizing a critical service to enhance security and reliability",
        "Led the end-to-end launch of an Instagram integration, expanding product offerings to a major consumer platform and unlocking new revenue opportunities"
      ]
    },
    {
      company: "Apryse",
      role: "Associate Product Manager",
      period: "2021 \u2014 2022",
      location: "Vancouver, BC",
      highlights: [
        "Drove product discovery and implementation for a new B2B2C video annotation tool through foundational user research",
        "Defined the MVP roadmap and collaborated with engineering to scope and deliver initial releases"
      ]
    }
  ],
  projects: [
    {
      name: "Tether",
      subtitle: "Social Connection Community",
      role: "Founder",
      period: "2025 \u2014 Present",
      context: "Side Project",
      description: "Building a community in Vancouver focused on helping people form friendships through curated social events. Grew to 100+ members with sold-out events.",
      tags: ["Community", "Event Design"],
      link: "https://flocksocial.app/c/red-envelope-society-d73e93",
      subtle: true
    },
    {
      name: "Communication Coaching",
      subtitle: "Interpersonal Skills & Confidence Building",
      role: "Founder & Coach",
      period: "2024 \u2014 Present",
      context: "Side Project",
      description: "Designed real-world practice frameworks to help people sharpen their communication skills and build social confidence. Delivered 70+ hours of 1-on-1 coaching with measurable client improvement across 15+ tracked metrics.",
      tags: ["Coaching", "Communication Design"],
      link: null,
      subtle: true
    },
    {
      name: "Edventure",
      subtitle: "Community-First E-Learning Platform",
      role: "Co-Founder & Product Lead",
      period: "2021",
      context: "UBC Accelerator",
      description: "Designed an MVP on Discord achieving a 70% project completion rate and 80% user satisfaction. Validated the concept through 50+ customer interviews, uncovering the role of community-driven motivation in online learning.",
      tags: ["Product Strategy", "MVP Design", "User Research"],
      link: null
    },
    {
      name: "BobaBot",
      subtitle: "At-Home Bubble Tea Machine",
      role: "Co-Founder",
      period: "2020",
      context: "Innovation Onboard Competition",
      description: "Validated consumer demand by securing a 300+ customer waitlist and interviewing 200+ potential users. Won 1st place out of 20 ventures and $5,000 in funding.",
      tags: ["Hardware", "Market Validation", "Prototyping"],
      link: null
    },
    {
      name: "ChatrMaps",
      subtitle: "Event-Specific Geolocation Chatrooms",
      role: "Developer",
      period: "2019",
      context: "Local Hack Day @ UBC",
      description: "Built a real-time platform enabling event-specific, geolocation-based chatrooms during Local Hack Day at UBC.",
      tags: ["JavaScript", "Geolocation", "Real-time"],
      link: "https://github.com/andyl2020/chatrmaps"
    }
  ],
  skills: {
    "Product": ["Product Strategy", "Roadmap Planning", "MVP Development", "User Research", "A/B Testing"],
    "Technical": ["System Architecture", "API Design", "Data Analysis", "Agile / Scrum"],
    "Leadership": ["Cross-functional Teams", "Stakeholder Management", "Enterprise Clients", "0 \u2192 1 Building", "Coaching"]
  }
};
